// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6fdb31ac","677":"aad47ad0"}[chunkId] + ".chunk.js";
};